import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import { ClientUploader } from "@redotech/redo-merchant-app-common/client/upload";
import { Flex } from "@redotech/redo-web/flex";
import { ImageUpload } from "@redotech/redo-web/image-upload";
import { Text } from "@redotech/redo-web/text";
import { memo, useId } from "react";

const MAX_FILE_SIZE_KB = 5000;
const RECOMMENDED_LONGEST_SIDE_PX = 2048;

export const StepImageUpload = memo(function StepImageUpload({
  imageUrl,
  setImageUrl,
}: {
  imageUrl: string | undefined;
  setImageUrl: (imageUrl: string | undefined) => void;
}) {
  const { t } = useTranslation();
  const id = useId();
  const handleChange = useHandler((url: URL | undefined) =>
    setImageUrl(url?.toString()),
  );
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        {t("Image")}
      </Text>
      <ClientUploader>
        <ImageUpload
          accept={["image/*"]}
          autoOptimizeImage
          id={id}
          maxFileSizeKb={MAX_FILE_SIZE_KB}
          onChange={handleChange}
          recommendedLongestSidePx={RECOMMENDED_LONGEST_SIDE_PX}
          showErrorMessages
          value={imageUrl ? new URL(imageUrl) : undefined}
        />
      </ClientUploader>
      <Text fontSize="xs" fontWeight="regular" textColor="secondary">
        {t("Optional. Shown to the warehouse worker as visual guidance.")}
      </Text>
    </Flex>
  );
});
